import InvestorInvestTable from './investor-invest-table';

export default InvestorInvestTable;
